<template>
    <b-nav-item-dropdown ref="dropdown" class="dropdown-notification mr-25" menu-class="dropdown-menu-media" right
        @shown="onDropdownShown">
        <template #button-content>
            <feather-icon :badge="eventsCount" badge-classes="bg-danger" class="text-body" icon="BellIcon" size="21"
                v-if="eventsCount > 0" />
            <feather-icon badge-classes="bg-danger" class="text-body" icon="BellIcon" size="21" v-else />
        </template>

        <!-- Header -->
        <li class="dropdown-menu-header">
            <div class="dropdown-header d-flex align-items-center">
                <h5 class="notification-title mb-0 mr-auto">
                    {{ $t('Notifications') }}
                </h5>
                <b-badge v-if="eventsCount > 0" pill variant="light-primary" class="cursor-pointer btn-mark-all"
                    @click.stop="removeAllAlerts">
                    <feather-icon icon="CheckIcon" size="14" class="mr-25" />
                    <span class="align-middle">{{ $t('Mark all as seen') }}</span>
                </b-badge>
            </div>
        </li>

        <!-- Notifications -->
        <vue-perfect-scrollbar :settings="perfectScrollbarSettings" class="scrollable-container media-list scroll-area"
            tagname="li">
            
            <!-- Skeleton Loaders -->
            <div v-if="isFetchingEvents" class="p-1">
               <b-media v-for="n in 5" :key="'skeleton-' + n" class="mb-1 align-items-center">
                    <template #aside>
                        <b-skeleton type="avatar" size="32px"></b-skeleton>
                    </template>
                    <b-skeleton width="85%" class="mb-25"></b-skeleton>
                    <b-skeleton width="55%"></b-skeleton>
               </b-media>
            </div>

            <!-- Empty State -->
            <div v-else-if="systemNotifications.length === 0" class="p-2 text-center text-muted">
                <feather-icon icon="BellOffIcon" size="32" class="mb-1 opacity-50" />
                <p class="mb-0">{{ $t('No new notifications') }}</p>
            </div>

            <!-- System Notifications -->
            <b-link v-else v-for="notification in systemNotifications" :key="notification.id"
                @click="hendleClickAlarm($event, notification.assetId, notification.id)" class="notification-item py-1">

                <b-media>
                    <template #aside>
                        <b-avatar size="32" variant="light-info">
                            <feather-icon icon="InfoIcon" />
                        </b-avatar>
                    </template>
                    <p class="media-heading">
                        <span class="font-weight-bolder">
                            {{ notification.name }}
                        </span>
                    </p>
                    <b-badge class="btn-mark mt-1 avoid-click" variant="primary" @click="removeAlert(notification.id)">
                        {{ $t('Mark as seen') }}
                    </b-badge>

                </b-media>

            </b-link>
        </vue-perfect-scrollbar>


    </b-nav-item-dropdown>
</template>

<script>
import {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    BButton,
    BFormCheckbox,
    BRow,
    BCol,
    BSkeleton
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'

import {
    ref,
    onUnmounted,
    getCurrentInstance,
} from '@vue/composition-api'
import systemStoreModule from '../systemStoreModule'
import router from '@/router'
import store from '@/store'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import {
    getCustomerIdFromAccessToken,
    isCustomerInCustomersToNotify,
} from '@/auth/jwtPayload'

export default {
    components: {
        BNavItemDropdown,
        BBadge,
        BMedia,
        BLink,
        BAvatar,
        VuePerfectScrollbar,
        BButton,
        BFormCheckbox,
        BRow,
        BCol,
        ToastificationContent,
        BSkeleton
    },
    directives: {
        Ripple,
    },
    data() {
        return {
            systemNotifications: [],
            eventsCount: 0,
            isFetchingEvents: false,
            lastFetchEventsAt: 0,
        }
    },
    methods: {
        closeDropdown() {
            this.$refs.dropdown.hide()
        },
        toAlarms(assetId) {
            this.$router.push({ name: 'settings-alarms', params: { id: assetId } })
        },

        hendleClickAlarm(event, assetId, alarmId) {

            if (!event.target.classList.contains('avoid-click')) {

                this.toAlarms(assetId)
                this.removeAlert(alarmId)
                this.closeDropdown()
            }
        },


        removeAlert(id) {

            this.closeDropdown()
            store.dispatch('app-system/fetchRemoveAlert', id)
                .then(response => {
                    //this.systemNotifications = []
                    this.fetchEvents()

                })
                .catch(error => {

                    //alert(error.response.status)
                })
        },

        removeAllAlerts() {
            this.closeDropdown()
            store.dispatch('app-system/fetchRemoveAllAlert')
                .then(response => {
                    this.fetchEvents()
                })
                .catch(() => {})
        },

        onDropdownShown() {
            this.fetchEvents()
        },

        fetchEvents() {
            const now = Date.now()
            // Evita spam quando o usuário clica repetidamente no sino
            if (this.isFetchingEvents) return
            if (now - this.lastFetchEventsAt < 800) return

            this.lastFetchEventsAt = now
            this.isFetchingEvents = true
            this.systemNotifications = []
            store.dispatch('app-system/fetchEvents')
                .then(response => {

                    this.$nextTick(() => {
                        this.systemNotifications = response.data.data
                        this.eventsCount = this.systemNotifications.length

                    })
                })
                .catch(() => {})
                .finally(() => {
                    this.isFetchingEvents = false
                })
        },

        registerEventBusListeners: function () {
            this.$root.$on("evt", this.event_evt);
        },

        deregisterEventBusListeners: function () {
            this.$root.$off("evt", this.event_evt);
        },


        event_evt: function (content) {
            const customerId = getCustomerIdFromAccessToken()
            if (!isCustomerInCustomersToNotify(content.customersToNotify, customerId)) {
                return
            }

            const eventKey = content.id ? content.id : JSON.stringify(content);

            // Evita processar o mesmo evento repetidamente em um curto intervalo
            if (this.lastProcessedEvents && this.lastProcessedEvents.includes(eventKey)) {
                return;
            }
            if (!this.lastProcessedEvents) this.lastProcessedEvents = [];
            this.lastProcessedEvents.push(eventKey);

            setTimeout(() => {
                const index = this.lastProcessedEvents.indexOf(eventKey);
                if (index > -1) this.lastProcessedEvents.splice(index, 1);
            }, 1000);

            //this.fetchEvents()
            this.eventsCount++
            this.showAlert(content.assetDescriptor, content.type.name)
        },

    },
    created() {
        this.fetchEvents()
    },
    mounted() {
        this.registerEventBusListeners();
    },
    beforeDestroy() {
        this.deregisterEventBusListeners();
    },
    setup() {
        /* eslint-disable global-require */
        const vm = getCurrentInstance().proxy
        const SYSTEM_APP_STORE_MODULE_NAME = 'app-system'

        // Register module
        if (!store.hasModule(SYSTEM_APP_STORE_MODULE_NAME)) store.registerModule(SYSTEM_APP_STORE_MODULE_NAME, systemStoreModule)

        // UnRegister on leave
        onUnmounted(() => {
            if (store.hasModule(SYSTEM_APP_STORE_MODULE_NAME)) store.unregisterModule(SYSTEM_APP_STORE_MODULE_NAME)
        })

        const toast = useToast()
        const show = ref(false);

        const clearAllToasts = () => {
            if (toast && typeof toast.clear === 'function') toast.clear()
            if (vm && typeof vm.closeDropdown === 'function') vm.closeDropdown()
        }

        const showAlert = (asset, alert) => {

            if (show.value) return

            show.value = true;

            setTimeout(() => {
                show.value = false;
            }, 2000);


            toast({
                component: ToastificationContent,
                props: {
                    title: alert,
                    text: `Ativo: ${asset}`,
                    icon: 'AlertCircleIcon',
                    variant: 'warning',
                    showClearAll: true,
                },
                listeners: {
                    'clear-all-toasts': clearAllToasts,
                },
            })
        }

        //const systemNotifications = ref([])

        const perfectScrollbarSettings = {
            maxScrollbarLength: 60,
            wheelPropagation: false,
        }

        return {
            SYSTEM_APP_STORE_MODULE_NAME,
            //systemNotifications,
            perfectScrollbarSettings,
            showAlert,
            clearAllToasts,
        }
    },
}
</script>

<style scoped>
.btn-mark:hover {
    box-shadow: 0px 3px 10px #7367f0de;
}
.btn-mark-all {
    transition: all 0.2s ease-in-out;
    padding: 0.4rem 0.6rem;
}
.btn-mark-all:hover {
    box-shadow: 0px 4px 8px rgba(115, 103, 240, 0.4);
    transform: translateY(-1px);
}
.notification-item {
    transition: background-color 0.2s ease;
}
.notification-item:hover {
    background-color: rgba(var(--primary-rgb), 0.05);
}
</style>
